var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.24 510.43c-17 0-30.24-13.78-30.24-31.36V32.93C0 15.35 13.28 1.57 30.25 1.57a32.73 32.73 0 0 1 16.3 4.49l336.84 223.06c10.07 5.81 16.08 15.86 16.08 26.88s-6 21.07-16.08 26.87L46.55 505.94a32.72 32.72 0 0 1-16.3 4.49h-.01Z",
    fill: "#3B6072"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M450.06 499.51a61.94 61.94 0 0 1-61.94-61.93V74.42a61.94 61.94 0 0 1 123.88 0v363.16a61.94 61.94 0 0 1-61.94 61.93Z",
    fill: "#3B6072"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayNext);
export default __webpack_public_path__ + "static/media/play-next.e0792decb0fda2a7dc7e56d045c0f841.svg";
export { ForwardRef as ReactComponent };